import * as R from 'ramda'
import * as RE from 'helpers/ramda-ext'
import { GroupBy2Filled, IsOdd, IsOddLength } from './offers.types'

const isOdd: IsOdd = R.modulo(R.__, 2)
const isOddLength: IsOddLength = R.compose(isOdd, R.length)

export const groupBy2Filled: GroupBy2Filled = R.when(RE.isNotNil,
  R.pipe(
    R.when(isOddLength, R.append(undefined)),
    R.splitEvery(2)
  )
)
